import { Link } from 'react-router-dom';
import type { Review } from '@/types/customer';
import { services } from '@/mocks/services';

export default function ReviewCard({ review }: { review: Review }) {
  const svc = services.find((s) => s.slug === review.serviceSlug);
  return (
    <article className="flex h-full flex-col rounded-xl border border-background-200 bg-white p-6 md:p-7">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-0.5 text-primary-500" aria-label={`Sample rating ${review.rating} of 5`}>
          {[1, 2, 3, 4, 5].map((n) => (
            <span key={n} className="flex h-4 w-4 items-center justify-center text-sm">
              <i className={n <= review.rating ? 'ri-star-fill' : 'ri-star-line'} />
            </span>
          ))}
        </div>
        {review.isSample && <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] uppercase tracking-[0.1em] text-accent-900">Sample</span>}
      </div>
      <p className="mt-5 flex-1 text-[15px] leading-relaxed text-foreground-800">{review.text}</p>
      <div className="mt-6 border-t border-background-200 pt-4 text-xs text-foreground-600">
        <p className="text-sm text-foreground-950">{review.displayName}</p>
        <p className="mt-1 flex flex-wrap gap-x-2">
          <span>{review.date}</span>
          <span>&middot;</span>
          {svc ? <Link to={`/services/${svc.slug}`} className="mw-link hover:text-foreground-950">{svc.name}</Link> : null}
        </p>
      </div>
    </article>
  );
}